var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{attrs:{"app":""}},[_c('span',{staticClass:"caption"},[_vm._v("© 2026 InspecTech AB")]),_vm._l((_vm.links),function(link){return _c('a',{key:link.href,staticClass:"ml-5 tiny caption grey--text text-decoration-none",attrs:{"href":link.href,"target":"_blank","rel":"noopener"},domProps:{"textContent":_vm._s(link.text)}})})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }